<div class="space-y-5">

  <!-- Método de pago -->
  <div *ngIf="!fixedMethod">
    <label class="block text-sm font-medium text-gray-700 mb-3">Método de Pago *</label>
    <div class="grid grid-cols-3 gap-3">
      <button type="button"
        (click)="selectMethod('cash')"
        [ngClass]="{
          'bg-green-500 text-white border-green-500': paymentMethod === 'cash',
          'text-gray-600 border-gray-200 hover:border-green-300 bg-white': paymentMethod !== 'cash'
        }"
        class="flex flex-col items-center py-4 px-3 border-2 rounded-2xl transition-all duration-200 cursor-pointer">
        <svg class="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z"></path>
        </svg>
        <span class="text-sm font-semibold">Efectivo</span>
      </button>
      <button type="button"
        (click)="selectMethod('card')"
        [ngClass]="{
          'bg-blue-500 text-white border-blue-500': paymentMethod === 'card',
          'text-gray-600 border-gray-200 hover:border-blue-300 bg-white': paymentMethod !== 'card'
        }"
        class="flex flex-col items-center py-4 px-3 border-2 rounded-2xl transition-all duration-200 cursor-pointer">
        <svg class="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
        </svg>
        <span class="text-sm font-semibold">Tarjeta</span>
      </button>
      <button type="button"
        (click)="selectMethod('split')"
        [ngClass]="{
          'bg-orange-500 text-white border-orange-500': paymentMethod === 'split',
          'text-gray-600 border-gray-200 hover:border-orange-300 bg-white': paymentMethod !== 'split'
        }"
        class="flex flex-col items-center py-4 px-3 border-2 rounded-2xl transition-all duration-200 cursor-pointer">
        <svg class="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path>
        </svg>
        <span class="text-sm font-semibold">Fraccionado</span>
      </button>
    </div>
  </div>

  <!-- Selector TPV -->
  <div *ngIf="paymentMethod === 'card' || paymentMethod === 'split'">
    <label class="block text-sm font-medium text-gray-700 mb-2">TPV (Terminal Punto de Venta) *</label>
    <p-dropdown
      [(ngModel)]="posTerminalId"
      (ngModelChange)="onPosTerminalChange()"
      [options]="posTerminalsList"
      optionLabel="name"
      optionValue="id"
      placeholder="Selecciona un TPV..."
      variant="filled"
      [filter]="true"
      filterBy="name"
      appendTo="body"
      styleClass="w-full">
    </p-dropdown>
  </div>

  <!-- Distribución fraccionado -->
  <div *ngIf="paymentMethod === 'split' && totalAmount"
    class="bg-orange-50 border border-orange-100 rounded-2xl p-5 space-y-4">
    <p class="text-sm font-semibold text-orange-700">
      Distribuye el pago — Total a repartir: <span class="text-orange-900">{{ totalAmount | number:'1.2-2' }} €</span>
    </p>
    <div class="grid grid-cols-2 gap-4">
      <div>
        <label class="block text-xs font-medium text-gray-600 mb-1">Efectivo (€)</label>
        <input type="number" [(ngModel)]="cashAmount" (ngModelChange)="onCashAmountChange()"
          min="0" [max]="totalAmount" step="0.01"
          class="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-gray-800 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent"
          placeholder="0.00">
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 mb-1">Tarjeta (€)</label>
        <input type="number" [(ngModel)]="cardAmount" (ngModelChange)="onCardAmountChange()"
          min="0" [max]="totalAmount" step="0.01"
          class="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-gray-800 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent"
          placeholder="0.00">
      </div>
    </div>
    <!-- Validación de suma -->
    <div class="flex items-center justify-between pt-2 border-t border-orange-200">
      <span class="text-sm text-gray-500">Total indicado:</span>
      <span class="font-bold text-base"
        [ngClass]="splitAmountsValid ? 'text-green-600' : 'text-red-500'">
        {{ ((cashAmount || 0) + (cardAmount || 0)) | number:'1.2-2' }} €
        <span *ngIf="splitAmountsValid"> ✓</span>
        <span *ngIf="!splitAmountsValid" class="text-xs font-normal ml-1">
          (debe ser {{ totalAmount | number:'1.2-2' }} €)
        </span>
      </span>
    </div>
  </div>

  <!-- Mensaje fraccionado sin total -->
  <div *ngIf="paymentMethod === 'split' && !totalAmount"
    class="bg-gray-50 border border-gray-200 rounded-2xl p-4 text-sm text-gray-500 text-center">
    Indica un importe para distribuir el pago.
  </div>

</div>
